import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Provider from "pubsub-js";
import Mediator from "../../services/Mediator";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import NoSsr from "@material-ui/core/NoSsr";
import CropIcon from "@material-ui/icons/Crop";
import CloseIcon from "@material-ui/icons/Close";
import {withStyles} from "@material-ui/core/styles";
import {CROP_APPLYIED} from "../../constants/event-types";
import {cropsSelector} from "../../selectors";
import {applyCrop} from "../../AC/apply-crop";

const styles = {
  root: {
    padding: `12px`,
    borderRadius: `3px`
  }
};

class Crop extends Component {
  static propTypes = {
    toggleEffect: PropTypes.func,
    selected: PropTypes.object,
    classes: PropTypes.object,
    crops: PropTypes.array,
    applyCrop: PropTypes.func
  };
  state = {
    clipPath: null,
    isOpen: false
  };
  setStateFromOImage = (oImage) => {
    const {clipPath} = oImage;
    this.setState({
      clipPath
    });
  };
  componentDidMount() {
    Provider.subscribe(CROP_APPLYIED, (_, target) => {
      this.setStateFromOImage(target);
    });
  }
  componentDidUpdate(prevProps) {
    const {selected: prevSelected} = prevProps;
    const {selected} = this.props;
    if (
      selected &&
      Mediator.isImage(selected) &&
      JSON.stringify(selected) !== JSON.stringify(prevSelected)
    ) {
      this.setStateFromOImage(selected);
    }
  }
  componentWillUnmount() {
    Provider.unsubscribe(CROP_APPLYIED);
  }
  showPopup = () => {
    this.setState({
      isOpen: true
    });
  };
  hidePopup = () => {
    this.setState({
      isOpen: false
    });
  };
  applyCrop = (cropUrl) => () => {
    this.props.applyCrop(cropUrl);
  };
  render() {
    const {isOpen} = this.state;
    const {selected, classes, crops} = this.props;
    return (
      selected &&
      Mediator.isImage(selected) && (
        <NoSsr>
          <div className="panel-control__item">
            <Tooltip title="Обрезать">
              <div>
                <IconButton
                  classes={{root: classes.root}}
                  onClick={this.showPopup}
                >
                  <CropIcon />
                </IconButton>
              </div>
            </Tooltip>
          </div>
          {isOpen && (
            <div className="panel-popup">
              <div className="crops">
                <div
                  className={`crops__item${
                    !selected.clipPath ? ` crops__item_active` : ``
                  }`}
                  onClick={this.applyCrop(null)}
                >
                  <span className="crops__cancel" />
                </div>
                {crops.map(({id, preview, original}) => {
                  const active =
                    selected.clipPath && selected.clipPath.id === original;
                  return (
                    <div
                      key={id}
                      className={`crops__item${
                        active ? ` crops__item_active` : ``
                      }`}
                      onClick={this.applyCrop(original)}
                    >
                      <img loading="lazy" src={preview} />
                    </div>
                  );
                })}
              </div>
              <div className="panel-popup__close">
                <IconButton onClick={this.hidePopup}>
                  <CloseIcon />
                </IconButton>
              </div>
            </div>
          )}
        </NoSsr>
      )
    );
  }
}

export default connect(
  (state) => ({
    crops: cropsSelector(state)
  }),
  {
    applyCrop
  }
)(withStyles(styles)(Crop));
